<template lang="html">
  <div :class="['cascader-wrap', visible ? 'active' : '', extraCls]" v-if="source && source.length">
    <div class="cascader-title" @click="toggle">
      <span v-if="selectedItems && selectedItems.length">{{selectedItems | stringify(textField) }}</span>
      <span v-else class="placeholder">{{hint}}</span>
      <i class="iconfont cascader-icon">&#xe661;</i>
    </div>
    <div class="cascader-picker" v-show="visible">
      <!-- 搜索框 -->
      <div class="cascader-search" v-if="enableSearch">
        <input type="text" v-model="searchKey" :placeholder="placeholder">
      </div>
      <!-- 已选中项 -->
      <div class="cascader-router" v-if="selectedItems && selectedItems.length">
        <span>已选择:</span>
        <template v-for="(item, idx) in selectedItems">
          <a :key="`Link-${idx}`" @click.prevent.stop="onResetSelected(item, idx)" class="router-item">
            {{item[textField]}}
          </a>
          <span :key="`Spliter-${idx}`" v-if="selectedItems && ((selectedItems.length - 1) !== idx)" class="router-spliter">></span>
        </template>
      </div>
      <div class="cascader-content">
        <ul class="cascader-options" v-if="currentItems && currentItems.length && currentItems[currentIndex].length">
          <li v-for="(item, idx) in currentItems[currentIndex]" :key="idx"
            :class="{ active: selectedItems && selectedItems.length && selectedItems[currentIndex] && item[valueField] === selectedItems[currentIndex][valueField] }"
            @click.stop="onItemSelected(item)"
          ><div>{{ item[textField] }}</div></li>
        </ul>
        <ul class="cascader-options" v-else>
          <li><div>没有匹配项</div></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<!-- 
  https://zhhshen.github.io/vue-zh/#/
  https://github.com/zhhshen/vue-zh/blob/master/src/components/Form/FormOrganization.vue
-->

<script>
export default {
  name: 'Cascader',
  props: {
    source: { type: Array, default: () => [] },
    hint: { type: String, default: '请选择' },
    value: { required: false },
    textField: { type: String, default: "label" },
    valueField: { type: String, default: "code" },
    childField: { type: String, default: "children" },
    extraCls: { type: String, default: "" },
    enableValues: { type: Boolean, default: true },
    enableSearch: { type: Boolean, default: false },
    placeholder: { type: String, default: '搜索' },
    customStyle: { type: Object, default: () => {} }
  },
  data () {
    return {
      currentIndex: 0, // 级联下标
      selectedItems: [], // 已选中的项
      visible: false,
      searchKey: ''
    }
  },
  watch: {
    value (newVal) {
      this.inputValue = newVal
    }
  },
  created () {
    // 缓存原始数据(注意不要修改原始数据)
    this.originSource = this.source;
    // 默认赋值
    if (this.value && this.value.join("").replace(/\s+/, "") != "") this.initSelectedItems();
  },
  mounted() { },
  computed: {
    currentItems() {
      let ret = [];
      let originSource = Array.from(this.originSource);
      // 
      if (this.enableSearch && this.searchKey) {
        // 
      } else if (Array.isArray(this.selectedItems) && this.selectedItems.length) {
        let items = originSource, pushed = false;
        this.selectedItems.forEach(vItem => {
          ret.push(
            items.map(item => {
              return {
                [this.textField]: item[this.textField],
                [this.valueField]: item[this.valueField],
                isLeaf: !item[this.childField] || !item[this.childField].length
              };
            })
          );
          pushed = true;
          let mItem = items.find(item => item[this.valueField] === vItem[this.valueField]);
          if (mItem && mItem[this.textField] && mItem[this.valueField]) {
            if (Array.isArray(mItem[this.childField]) && mItem[this.childField].length) {
              items = mItem[this.childField];
              pushed = false;
            }
          }
        });
        if (!pushed) {
          ret.push(
            items.map(item => {
              return {
                [this.textField]: item[this.textField],
                [this.valueField]: item[this.valueField],
                isLeaf: !item[this.childField] || !item[this.childField].length
              };
            })
          );
        }
      } else {
        ret = [originSource];
      }
      return ret;
    }
  },
  methods: {
    // 初始化默认选中项
    initSelectedItems() {
      if (Array.isArray(this.value)) {
        // 
        let items = Array.from(this.originSource);
        let selectedItems = [];
        this.value.forEach(vItem => {
          let mItem = items.find(item => item[this.textField] === vItem || item[this.valueField] === vItem);
          if (mItem && mItem[this.textField] && mItem[this.valueField]) {
            selectedItems.push({
              [this.textField]: mItem[this.textField],
              [this.valueField]: mItem[this.valueField]
            });
            if (Array.isArray(mItem[this.childField]) && mItem[this.childField].length) {
              items = mItem[this.childField];
            }
          }
        });
        this.selectedItems = selectedItems;
        // 
        this.currentIndex = Math.max(this.selectedItems.length - 1, 0);
      }
    },
    // 切换显示隐藏
    toggle() {
      this.visible = !this.visible;
      if (this.visible) {
        window.addEventListener("click", this.clickHandler, false);
      } else {
        window.removeEventListener("click", this.clickHandler, false);
      }
    },
    // 组件外点击时关闭
    clickHandler(evt) {
      let dom = evt.target || evt.srcElement;
      if (!this.$el.contains(dom)) {
        this.visible = false;
      }
    },
    // 选中处理
    onItemSelected(item) {
      let newIndex = this.currentIndex + 1;
      this.$set(this.selectedItems, this.currentIndex, item);
      if (!item.isLeaf && this.currentItems[newIndex]) {
        this.currentIndex = newIndex;
      } else if (!item.isLeaf && !this.currentItems[newIndex]) {
        console.warn("Warning");
      } else if (item.isLeaf) {
        this.visible = false;
        this.$emit('input', this.selectedItems.map(item => item[this.valueField]));
      }
    },
    // 重置选中
    onResetSelected(item, idx) {
      this.currentIndex = idx;
      this.selectedItems.splice(idx);
    }
  },
  filters: {
    stringify: function (value, showField, spliter='/') {
      return value.length ? value.map(item => item[showField]).join(spliter) : '';
    }
  },
  beforeDestroy () {}
}
</script>

<style scoped>
/*级联选择器*/
.cascader-wrap {display: inline-flex; position: relative; width: 100%; }
.cascader-title { position: relative; width: 100%; height: 100%; line-height: 28px; padding: 5px 10px; border-bottom: 1px solid rgba(81,130,228,.5); }
.cascader-wrap.active .cascader-title { border-bottom-left-radius: 0; border-bottom-right-radius: 0; }
.cascader-title .placeholder { color: #999999; }
.cascader-icon { position: absolute; display: inline-block; top: 0px; right: 0; font-size: 10px; height: 45px; line-height: 45px; padding: 0 10px; color: #BCBCBC; transform: scale(0.5); transition: transform 0.2s ease; cursor: pointer; }
.active .cascader-icon {
  transform: scale(0.5) rotate(180deg);
}
.cascader-picker {
  position: absolute; top: 45px; left: 0px; z-index: 100;
  /* width: calc(100% - 1.40625rem - 1.40625rem); left: 1.40625rem; */
  width: 100%; height: auto; min-height: 100px; max-height: 300px;
  background: #fff; border-radius: 3px; overflow: hidden;
  box-shadow: 0 0 6px 0 rgba(0,0,0,.1), 0 0 12px 5px rgba(0,0,0,.1);
}
.cascader-search { padding: 10px; }
.cascader-search input {
  width: 100%;
  height: 34px;
  padding: 5px;
  border: none;
  border-bottom: 1px solid rgba(81,130,228,.5);
  outline: none;
}
.cascader-router { display: flex; justify-content: flex-start; align-items: center; line-height: 20px; padding: 5px 10px; width: 100%; overflow-x: scroll; }
.cascader-router .router-item { margin-left: 4px; cursor: pointer; text-decoration: none; }
.cascader-router .router-spliter { margin-left: 4px; }
.ms-organization-body-top { bottom: 60px; }
.cascader-content {
  /*padding: 15px 10px;*/
}
.cascader-options { list-style: none; overflow-y: scroll; overflow-x: hidden; max-height: 160px; margin-bottom: 0; }
.cascader-options li { padding: 10px; cursor: pointer; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: rgba(10,18,32,.64) }
.cascader-options li:hover{ color: rgba(10,18,32,.87); background-color: rgba(232,235,237,.6) }
.cascader-options li.active{ color: rgba(81,130,228,1); }
</style>